import type { FC } from "react";
import { Body, styled } from "@kivra/react-components";
import { CheckmarkCircleIcon } from "@kivra/react-components/icons";
import { useCopy } from "../../utils/globalContext";
import { KivraHeader } from "../header/KivraHeader";

export const Instructions: FC = () => {
  const copy = useCopy();

  const InstructionRow = ({ content }: { content: string }) => (
    <Row>
      <Icon size={24} _color="rgb(118, 200, 46)" />
      <ContentRow size="medium">{content}</ContentRow>
    </Row>
  );

  return (
    <Container>
      <KivraHeader title={copy("auth_onboarding_title")} />
      <InstructionRow content={copy("auth_onboarding_item_1")} />
      <InstructionRow content={copy("auth_onboarding_item_2")} />
      <InstructionRow content={copy("auth_onboarding_item_3")} />
    </Container>
  );
};

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  maxWidth: "343px",
});

const Row = styled.div({
  display: "flex",
  gap: "$spacing-16",
});

const ContentRow = styled(Body)({
  margin: [0, 0, "$spacing-20", 0],
});

const Icon = styled(CheckmarkCircleIcon)({
  flex: "0 0 16px",
  paddingTop: "$spacing-4",
});
